"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwShellLeftNav = _interopRequireDefault(require("./CwShellLeftNav.scss"));

var _CwImage = _interopRequireDefault(require("../cwimage/CwImage"));

var _constants = require("./constants");

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));

var CwShellLeftNav = function CwShellLeftNav(props) {
  var _cx;

  var cwShellLeftNavClass = (0, _classnames.default)(_CwShellLeftNav.default.cwShellLeftNav, (_cx = {}, (0, _defineProperty2.default)(_cx, _CwShellLeftNav.default.collapsed, props.expand === _constants.CwShellLeftNavExpand.COLLAPSED), (0, _defineProperty2.default)(_cx, _CwShellLeftNav.default.default, props.expand === _constants.CwShellLeftNavExpand.DEFAULT), (0, _defineProperty2.default)(_cx, _CwShellLeftNav.default.fat, props.expand === _constants.CwShellLeftNavExpand.FAT), (0, _defineProperty2.default)(_cx, _CwShellLeftNav.default.skinny, props.expand === _constants.CwShellLeftNavExpand.SKINNY), _cx));
  var collapseIconClass = (0, _classnames.default)(_CwShellLeftNav.default.expansionIcon, _CwShellLeftNav.default.collapseIcon, (0, _defineProperty2.default)({}, _CwShellLeftNav.default.fat, props.expand === _constants.CwShellLeftNavExpand.FAT));
  var expandIconClass = (0, _classnames.default)(_CwShellLeftNav.default.expansionIcon, _CwShellLeftNav.default.expandIcon, (0, _defineProperty2.default)({}, _CwShellLeftNav.default.collapsed, props.expand === _constants.CwShellLeftNavExpand.COLLAPSED));

  var renderChildren = function renderChildren() {
    return _react.default.Children.map(props.children, function (child) {
      return child ? _react.default.cloneElement(child, {
        cwId: props.cwId,
        active: props.activeButton === child.props.id,
        activeLink: props.activeLink,
        activeButton: props.activeButton,
        collapseIcon: props.collapseIconUp,
        expandIcon: props.expandIconDown,
        expand: props.expand,
        setActiveButton: props.setActiveButton,
        setActiveLink: props.setActiveLink
      }) : _react.default.createElement('span');
    });
  };

  return _react.default.createElement("div", {
    className: cwShellLeftNavClass,
    style: props.style
  }, props.expand !== _constants.CwShellLeftNavExpand.SKINNY && _react.default.createElement("div", {
    className: _CwShellLeftNav.default.expansionIconContainer
  }, props.expand !== _constants.CwShellLeftNavExpand.COLLAPSED && _react.default.createElement(_CwImage.default, {
    className: collapseIconClass,
    src: props.collapseIconLeft,
    onClick: props.handleCollapse
  }), props.expand !== _constants.CwShellLeftNavExpand.FAT && _react.default.createElement(_CwImage.default, {
    className: expandIconClass,
    src: props.expandIconRight,
    onClick: props.handleExpand
  })), _react.default.createElement("div", {
    style: {
      clear: 'both'
    }
  }), props.expand !== _constants.CwShellLeftNavExpand.COLLAPSED && _react.default.createElement("div", {
    className: _CwShellLeftNav.default.cwShellLeftNavContainer
  }, renderChildren()));
};

CwShellLeftNav.propTypes = {
  children: _propTypes.default.any,

  /**
   *  Connectwise element id to be used as unique identifier
   **/
  cwId: _propTypes.default.string,

  /**
   * Id of active menu button
   */
  activeButton: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Id of active menu link
   */
  activeLink: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Determines the expansion style of the menu.
   */
  expand: _propTypes.default.oneOf([_constants.CwShellLeftNavExpand.COLLAPSED, _constants.CwShellLeftNavExpand.DEFAULT, _constants.CwShellLeftNavExpand.FAT, _constants.CwShellLeftNavExpand.SKINNY]),

  /**
   * Path to collapse icon (left nav expansion)
   */
  collapseIconLeft: _propTypes.default.string,

  /**
   * Path to collapse icon (sub menu expansion)
   */
  collapseIconUp: _propTypes.default.string,

  /**
   * Path to expand icon (left nav expansion)
   */
  expandIconRight: _propTypes.default.string,

  /**
   * Path to expand icon (sub menu expansion)
   */
  expandIconDown: _propTypes.default.string,

  /**
   * Callback function that is fired on collapse button press
   */
  handleCollapse: _propTypes.default.func,

  /**
   * Callback function that is fired on expand button press
   */
  handleExpand: _propTypes.default.func,

  /**
   * Callback function to set the active button
   */
  setActiveButton: _propTypes.default.func,

  /**
   * Callback function to set the active link
   */
  setActiveLink: _propTypes.default.func,

  /**
   * Allows custom styling
   */
  style: _propTypes.default.object
};
CwShellLeftNav.defaultProps = {
  cwId: '',
  collapseIconLeft: _IconPath.default.get('Action_Back'),
  collapseIconUp: _IconPath.default.get('Action_CollapseUp'),
  expandIconRight: _IconPath.default.get('Action_Forward'),
  expandIconDown: _IconPath.default.get('Action_ExpandDown')
};
var _default = CwShellLeftNav;
exports.default = _default;